import { Select, styled } from "@mui/material";
export const CssSelect = styled(Select)({
  '&.Mui-focused .MuiOutlinedInput-notchedOutline':{
    borderColor: '#042630',
  }
});
